/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Not_Enough_Coins_GuideInputs */

const en_dialog_not_enough_coins_guide = /** @type {(inputs: Dialog_Not_Enough_Coins_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep focusing to earn more coins, or get the Boosting Pack for an instant top-up!`)
};

const ar_dialog_not_enough_coins_guide = /** @type {(inputs: Dialog_Not_Enough_Coins_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`استمر في التركيز لكسب المزيد من العملات، أو احصل على حزمة التعزيز لإعادة شحن فورية!`)
};

const de_dialog_not_enough_coins_guide = /** @type {(inputs: Dialog_Not_Enough_Coins_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fokussiere weiter, um mehr Münzen zu verdienen, oder hol dir das Boosting-Paket für ein sofortiges Aufladen!`)
};

const es_dialog_not_enough_coins_guide = /** @type {(inputs: Dialog_Not_Enough_Coins_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Sigue concentrándote para ganar más monedas, u obtén el Pack de Impulso para una recarga instantánea!`)
};

const fr_dialog_not_enough_coins_guide = /** @type {(inputs: Dialog_Not_Enough_Coins_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue à te concentrer pour gagner plus de pièces, ou obtiens le Pack Booster pour un rechargement instantané !`)
};

const it_dialog_not_enough_coins_guide = /** @type {(inputs: Dialog_Not_Enough_Coins_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continua a concentrarti per guadagnare più monete, o ottieni il Pacchetto Boost per una ricarica istantanea!`)
};

const ja_dialog_not_enough_coins_guide = /** @type {(inputs: Dialog_Not_Enough_Coins_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`集中してコインをもっと獲得するか、ブーストパックで今すぐチャージしよう！`)
};

const ko_dialog_not_enough_coins_guide = /** @type {(inputs: Dialog_Not_Enough_Coins_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`계속 집중해서 코인을 모으거나, 부스팅 팩으로 즉시 충전하세요!`)
};

const pt_br_dialog_not_enough_coins_guide = /** @type {(inputs: Dialog_Not_Enough_Coins_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue focando para ganhar mais moedas, ou adquira o Pacote Boost para recarga instantânea!`)
};

const ru_dialog_not_enough_coins_guide = /** @type {(inputs: Dialog_Not_Enough_Coins_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продолжай фокусироваться, чтобы зарабатывать больше монет, или получи Бустерный пакет для мгновенного пополнения!`)
};

const th_dialog_not_enough_coins_guide = /** @type {(inputs: Dialog_Not_Enough_Coins_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`โฟกัสต่อไปเพื่อสะสมเหรียญเพิ่ม หรือรับ Boosting Pack เพื่อเติมเต็มทันที!`)
};

const tr_dialog_not_enough_coins_guide = /** @type {(inputs: Dialog_Not_Enough_Coins_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daha fazla jeton kazanmak için odaklanmaya devam et ya da anında dolum için Hızlandırma Paketini al!`)
};

const zh_cn_dialog_not_enough_coins_guide = /** @type {(inputs: Dialog_Not_Enough_Coins_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前往专注累积更多金币，或选购加速礼包快速加值！`)
};

const zh_tw_dialog_not_enough_coins_guide = /** @type {(inputs: Dialog_Not_Enough_Coins_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前往專注累積更多金幣，或選購加速禮包快速加值！`)
};

/**
* | output |
* | --- |
* | "Keep focusing to earn more coins, or get the Boosting Pack for an instant top-up!" |
*
* @param {Dialog_Not_Enough_Coins_GuideInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_not_enough_coins_guide = /** @type {((inputs?: Dialog_Not_Enough_Coins_GuideInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Not_Enough_Coins_GuideInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_not_enough_coins_guide(inputs)
	if (locale === "ar") return ar_dialog_not_enough_coins_guide(inputs)
	if (locale === "de") return de_dialog_not_enough_coins_guide(inputs)
	if (locale === "es") return es_dialog_not_enough_coins_guide(inputs)
	if (locale === "fr") return fr_dialog_not_enough_coins_guide(inputs)
	if (locale === "it") return it_dialog_not_enough_coins_guide(inputs)
	if (locale === "ja") return ja_dialog_not_enough_coins_guide(inputs)
	if (locale === "ko") return ko_dialog_not_enough_coins_guide(inputs)
	if (locale === "pt_br") return pt_br_dialog_not_enough_coins_guide(inputs)
	if (locale === "ru") return ru_dialog_not_enough_coins_guide(inputs)
	if (locale === "th") return th_dialog_not_enough_coins_guide(inputs)
	if (locale === "tr") return tr_dialog_not_enough_coins_guide(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_not_enough_coins_guide(inputs)
	return zh_tw_dialog_not_enough_coins_guide(inputs)
});